import cn from 'classnames';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';

import { TFullRentProduct, useActionsProducts, useBasketActions } from '@/entities/product';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Button } from '@/shared/ui/button';
import { ArrowRightIcon, BasketFullIcon, Basket2Icon, HeartIcon } from '@/shared/ui/icons';

import * as Styled from './styled';

type TProps = {
    product: TFullRentProduct;
    isStickyBottom?: boolean;
};

export const StandardControlButtons: FC<TProps> = ({ product, isStickyBottom }) => {
    const theme = useTheme();
    const { t } = useTranslate();
    const { handleAddProductToFavorite, favoriteProducts } = useActionsProducts({ product });
    const { handleAddProductToBasket, onReserveProduct, basketProducts } = useBasketActions({ product });
    const isFavorite = favoriteProducts?.includes(product.id);
    const isInBasket = basketProducts?.includes(product.id);

    if (isStickyBottom) {
        return (
            <Styled.Wrapper>
                {product.status === 'active' ? (
                    <>
                        <Styled.ProductTextButton isAwaitLoading onClick={onReserveProduct}>
                            <span>{t('Забронировать')}</span>
                            <span>
                                <ArrowRightIcon />
                            </span>
                        </Styled.ProductTextButton>
                    </>
                ) : (
                    <Button aria-label={t('Нет в наличии')} className="basket-btn" variant="neutral">
                        <>
                            <span> {t('Нет в наличии')} </span>
                        </>
                    </Button>
                )}
            </Styled.Wrapper>
        );
    }

    return (
        <Styled.Wrapper className="default">
            <div className="left">
                {product.status === 'active' ? (
                    <>
                        <Styled.ProductTextButton isAwaitLoading onClick={onReserveProduct} className="btn-reserve">
                            <span>{t('Забронировать')}</span>
                            <span>
                                <ArrowRightIcon />
                            </span>
                        </Styled.ProductTextButton>
                    </>
                ) : (
                    <Button aria-label={t('Нет в наличии')} className="basket-btn" variant="neutral">
                        <>
                            <span> {t('Нет в наличии')} </span>
                        </>
                    </Button>
                )}
            </div>
            <div className="right">
                {product.status === 'active' && (
                    <Button
                        aria-label={isInBasket ? t('В корзине') : t('В корзину')}
                        className={cn('fav-btn btn-panel', { active: isInBasket })}
                        outlined={true}
                        onClick={handleAddProductToBasket}
                    >
                        <>
                            {isInBasket ? (
                                <BasketFullIcon width={16} height={16} />
                            ) : (
                                <Basket2Icon width={16} height={16} />
                            )}
                            <span className="fav-label">{isInBasket ? t('В корзине') : t('В корзину')}</span>
                        </>
                    </Button>
                )}
                <Button
                    aria-label={isFavorite ? t('В избранном') : t('В избранное')}
                    className={cn('fav-btn btn-panel', { active: isInBasket })}
                    outlined={true}
                    onClick={handleAddProductToFavorite}
                >
                    <>
                        <HeartIcon color={theme.color.primary} width={16} height={16} filled={isFavorite} />
                        <span className="fav-label">{isFavorite ? t('В избранном') : t('В избранное')}</span>
                    </>
                </Button>
            </div>
        </Styled.Wrapper>
    );
};
